import React from "react";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Container, Row, Col, Button } from "react-bootstrap";

const Amenities = () => {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const offsetTop = el.offsetTop - 80; // Leave 100px space at the top
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const [showImageModal, setShowImageModal] = useState(false);

  return (
    <fragment>
      <div className="amenities">
        <section className="container amenities py-4">
          <div className="row g-4">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8 text-center">
                  <h3 className="display-6 fw-bold mb-3" data-aos="fade-up">
                    Project <span className="underline-slide">Overview</span>
                  </h3>
                </div>
              </div>
            </div>
            {/* Top Section - Map & Image */}
            <div className="col-md-6">
              <div className="position-relative rounded-4 overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3693.2288935745783!2d79.9603001!3d13.1321474!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a528f0075944e57%3A0xa060de56c366f3d5!2sGP%20HOMES%20PON%20BHOOMI!5e1!3m2!1sen!2sin!4v1748324478131!5m2!1sen!2sin"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="map-embed"
                />
                <a
                  href="https://maps.app.goo.gl/NpyvJDD9Wd4p3GoZ9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="position-absolute top-0 start-0 w-100 h-100"
                  style={{ zIndex: 2 }}
                >
                  <span className="visually-hidden">Open Map</span>
                </a>
                <div
                  className="position-absolute top-0 start-0 bg-dark bg-opacity-50 text-white p-3 rounded-end"
                  style={{ zIndex: 3 }}
                >
                  <i className="fas fa-map-marker-alt me-2"></i>Project Location
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="position-relative rounded-4 overflow-hidden shadow-lg"
                onClick={() => setShowImageModal(true)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src="	https://www.gphomes.in/static/media/Pon-Bhoomi-Sight-Plan.97e1e676a50f18fcd67b.jpg"
                  alt="Location"
                  className="img-fluid"
                  style={{ height: "400px", objectFit: "cover" }}
                />
                <div className="position-absolute top-0 start-0 bg-dark bg-opacity-50 text-white p-3 rounded-end">
                  <i className="fas fa-building me-2"></i>Project Overview
                </div>
              </div>

              {/* Modal for Enlarged Image */}
              <Modal
                show={showImageModal}
                onHide={() => setShowImageModal(false)}
                centered
                size="lg"
              >
                <Modal.Header closeButton />
                <Modal.Body className="text-center">
                  <img
                    src="	https://www.gphomes.in/static/media/Pon-Bhoomi-Sight-Plan.97e1e676a50f18fcd67b.jpg"
                    alt="Enlarged"
                    className="img-fluid"
                    style={{ maxHeight: "80vh", objectFit: "contain" }}
                  />
                </Modal.Body>
              </Modal>
            </div>

            {/* Content Sections with Gradient Background */}
            <div className="col-12 mt-5">
              <div className="bg-gradient-primary rounded-4 p-4 shadow-sm">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-4">
                      <div className="icon-wrapper bg-white rounded-circle p-3 me-3 shadow">
                        <i className="fas fa-train text-black fs-4"></i>
                      </div>
                      <h4 className="text-dark mb-0">Connectivity</h4>
                    </div>
                    <ul className="list-unstyled text-grey">
                      {[
                        "Sevvapet railway station",
                        "Avadi Bus depo",
                        "Outer ring road",
                      ].map((item, i) => (
                        <li key={i} className="d-flex align-items-center mb-3">
                          <i className="fas fa-circle text-black-50 me-2 small"></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-4">
                      <div className="icon-wrapper bg-white rounded-circle p-3 me-3 shadow">
                        <i className="fas fa-film text-black fs-4"></i>
                      </div>
                      <h4 className="text-dark mb-0">Entertainment</h4>
                    </div>
                    <ul className="list-unstyled text-grey">
                      {["Rakki Cinemas", "Fun Land", "Bulbul Park"].map(
                        (item, i) => (
                          <li
                            key={i}
                            className="d-flex align-items-center mb-3"
                          >
                            <i className="fas fa-circle text-black-50 me-2 small"></i>
                            {item}
                          </li>
                        )
                      )}
                    </ul>
                  </div>

                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-4">
                      <div className="icon-wrapper bg-white rounded-circle p-3 me-3 shadow">
                        <i className="fas fa-hospital text-black fs-4"></i>
                      </div>
                      <h4 className="text-dark mb-0">Healthcare</h4>
                    </div>

                    <ul className="list-unstyled text-grey">
                      {[
                        "Saviour Hospital",
                        "Government Hospital",
                        "ESI Hospital",
                      ].map((item, i) => (
                        <li key={i} className="d-flex align-items-center mb-3">
                          <i className="fas fa-circle text-black-50 me-2 small"></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-4">
                      <div className="icon-wrapper bg-white rounded-circle p-3 me-3 shadow">
                        <i className="fas fa-graduation-cap text-black fs-4"></i>
                      </div>
                      <h4 className="text-dark mb-0">Education</h4>
                    </div>
                    <ul className="list-unstyled text-grey">
                      {[
                        "Government Medical College",
                        "Bhajarang Engineering",
                        "John Bosco College",
                      ].map((item, i) => (
                        <li key={i} className="d-flex align-items-center mb-3">
                          <i className="fas fa-circle text-black-50 me-2 small"></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <style jsx>{`
        // .bg-gradient-primary {
        //   background: linear-gradient(135deg,rgb(255, 255, 255) 0%,rgb(220, 255, 225) 100%);
        // }
        .icon-wrapper {
          transition: transform 0.3s ease;
        }
        .icon-wrapper:hover {
          transform: scale(1.05);
        }
        .map-embed {
          filter: grayscale(0.3) contrast(1.1);
        }
      `}</style>
    </fragment>
  );
};

export default Amenities;
